import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '../../_services/dialog.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Location } from '../../_models/fundraising/Location';
import { VendorService } from '../../_services/fundraising/vendor.service';

@Component({
  selector: 'app-location-management',
  templateUrl: './location-management.component.html',
  styleUrls: ['../../_shared/base.management.component.css']
})

export class LocationManagementComponent implements OnInit {
  public loading = true;

  public displayLocations: Location[];
  public items: Location[];

  public searchText: string;

  private filterName(name:string, searchQuery:string): boolean{
    return name.toLowerCase().includes(searchQuery.toLowerCase())
  }

  public search() {
    this.displayLocations = this.items.filter(location => this.filterName(location.name, this.searchText) && location.active)
  }

  constructor(
    private router: Router,
    private vendorService: VendorService,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private spinner: NgxSpinnerService) {

  }

  ngOnInit() {
    this.load();
  }


  private load() {
    this.spinner.show();

    this.vendorService.getVendorLocations().subscribe(data => {
      this.displayLocations = data.filter(l => l.active);
      this.items = data;

      this.loading = false;
      this.spinner.hide();
    },
    error => {
      this.dialogService.alert(
        'Uh oh something went wrong...',
        `Unable to load locations: ${error.error}`,
        this.viewRef);

        this.loading = false;
        this.spinner.hide();
    });
  }

  public delete(id: number) {
    this.dialogService.confirm('Confirm Delete', 'Are you sure you want to inactivate this location?', this.viewRef)
      .then(result => {
        if (result) {
          this.loading = true;
          this.spinner.show();

          this.vendorService.deleteLocation(id)
          .subscribe(
            () => {
              this.spinner.hide();
              this.load();
          },
            error => {
              this.spinner.hide();
              this.dialogService.error(
                error,
                `Unable to inactivate this station`,
                this.viewRef);
          });

        }
    });
  }


  public create() {
    this.router.navigate(['/portal/fundraising/cue5050/location/create']);
  }

  public edit(id: number) {
    this.router.navigate([`/portal/fundraising/cue5050/location/update/${id}`]);
  }
}
